import { TemplatePage } from './types';

const artCulturePage: TemplatePage = {
  header: {
    color: '#D0DFC0',
    icon: 'images/video-templates/art-culture.jpg',
    title: 'Art and Culture Video Templates Collection',
    title_meta: '50+ Free and Customizable Art & Culture Video Templates',
    description_meta:
      'Inspire, amaze and thrill your audience with aesthetic videos about art and culture. Get a special set of video ' +
      'templates to make resonating videos.',
    description:
      'Ancient and modern, classy and provocative, dramatic and inspiring - there is so much about arts to show and ' +
      'discuss. Induce the conversation with your audience, spread the joy of creativity, or promote cultural events ' +
      'in your area. These video templates will help you create stunning videos on art and culture.'
  },
  footer: {
    category: 'Art & Culture',
    description:
      'Beautiful video templates coupled with rich customization features make a shortcut to effortless video production. ' +
      'Wave.video offers a rich collection of video templates featuring separate sets for diverse industries and use ' +
      'cases. Plus, all templates come in several sizes so that you can create consistently-looking video content for ' +
      'various platforms and channels. Browse video templates, pick out the ones you like, and easily transform them ' +
      'into your unique content pieces.'
  },
  content: [
    {
      type: 'templates',
      title: 'Art and Culture Video Templates',
      search: { category: '/Industries/Art & Culture' }
    },
    {
      type: 'stocks',
      title: 'art and culture',
      search: { name: 'art culture' }
    },
    { type: 'calendar' }
  ]
};

export default artCulturePage;
